import { Box, Modal, Paper } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner";

const data = [
    {
        visitdate: "Monday",
        reportvalue: 14,
        visitnumber: "V-LS/2023/002328",
        normalrange: "12 - 14",
        visittime: "06:06 PM",
    },

    {
        visitdate: "Tuesday",
        reportvalue: 15,
        visitnumber: "V-LS/2023/002328",
        normalrange: "12 - 14",
        visittime: "06:06 PM",
    },
];

const ViewTrendModal = ({
    openTrendModal,
    setOpenTrendModal,
    spinner,
    parameterTrendData,
    setParameterTrendData,
    graphData,
    currentParameterTrendData,
    selectedObjTest,
    patientDetails,
}) => {
    const between = (x, min, max) => {
        return x >= min && x <= max;
    };
    console.log("patientDetail7878", patientDetails);

    const [upperLimit, setUpperLimit] = useState(0);
    const [lowerLimit, setLowerLimit] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        if (parameterTrendData?.length > 0) {
            let numbersArr = [];
            setLowerLimit(0);
            setUpperLimit(0);
            console.log("parameterTrendData123", parameterTrendData);
            let maxVal, minVal;
            parameterTrendData?.forEach((item) => {
                // item.visitdate = new Date(item.visitdate).toLocaleDateString();
                if (item.normalrange !== null) {
                    let range = item.normalrange.split("-");

                    if (
                        !between(
                            parseFloat(item.reportvalue),
                            parseFloat(range[0]),
                            parseFloat(range[1])
                        )
                    ) {
                        numbersArr.push(parseFloat(item.reportvalue));
                    }
                }
            });
            console.log("numbersArr", numbersArr);
            maxVal = Math.max(...numbersArr);
            minVal = Math.min(...numbersArr);
            console.log("maxVal", maxVal);
            console.log("minVal", minVal);
            if (
                parameterTrendData[0].normalrange !== null &&
                parameterTrendData[0].normalrange !== " - "
            ) {
                let range = parameterTrendData[0].normalrange.split("-");
                if (minVal < parseFloat(range[0])) {
                    setLowerLimit(minVal);
                } else {
                    setLowerLimit(parseFloat(range[0]));
                }

                if (maxVal > parseFloat(range[1])) {
                    setUpperLimit(maxVal);
                } else {
                    setUpperLimit(parseFloat(range[1]));
                }
            }
        }
    }, [parameterTrendData]);

    useEffect(() => {
        // Function to update the width on window resize
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Add event listener to handle resize
        window.addEventListener("resize", handleResize);

        // Clean up the event listener on component unmount
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const chartWidth = windowWidth * 0.8;

    return (
        <>
            <Modal
                open={openTrendModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                disableAutoFocus
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "85%",
                        height: "95%",
                        bgcolor: "background.paper",
                        p: 2,
                        //   borderRadius: 1,
                        overflow: "scroll",
                    }}
                >
                    <div className="flex flex-col space-y-2">
                        <div className="flex items-center justify-between">
                            <div>
                                <span className="font-semibold text-lg">Parameter Trend</span>
                            </div>
                            <div>
                                <button type="button" onClick={() => setOpenTrendModal(false)}>
                                    <CloseModalIcon />
                                </button>
                            </div>
                        </div>
                        <div className="grid lg:grid-cols-2 xl:flex xl:justify-between gap-2 px-2 py-1 border bg-gray-100 rounded-md text-sm">
                            <div className="flex items-center space-x-2">
                                <span className="font-semibold w-40 lg:w-28">Patient Name</span>
                                <span>:</span>
                                <span className="text-customBlue font-bold text-base">
                                    {patientDetails?.patientName ||
                                        patientDetails?.["Patient Name"]}
                                </span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <span className="font-semibold w-40 xl:w-10">UHID </span>
                                <span className="text-gray-500">
                                    :&nbsp;{patientDetails?.uhid || patientDetails?.UHID}
                                </span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <span className="font-semibold w-40 lg:w-28 xl:w-10">Age</span>
                                <span className="text-gray-500">
                                    :&nbsp;{patientDetails?.age || patientDetails?.Age}
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center space-x-4 bg-gray-100 px-2 py-1">
                            <div className="font-semibold">Test Name</div>
                            <span className="text-gray-500">
                                : {selectedObjTest?.TestName || selectedObjTest?.testName}
                            </span>
                            <div className="font-semibold">Parameter Name</div>
                            <span className="text-gray-500">
                                : {currentParameterTrendData?.parameterName}
                            </span>
                            <div className="font-semibold">Normal Range</div>
                            <span className="text-gray-500">
                                : {currentParameterTrendData?.normalRange}
                            </span>
                        </div>
                        {/* <div className="w-full ml-2">
                <p className="font-semibold text-sm mb-4 text-customBlue">
                
                </p>
              </div> */}
                        {/* <AreaChart
              width={1200}
              height={300}
              data={graphData}
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="formattedVisitDate" />
              <YAxis
                dataKey="reportvalue"
                domain={[lowerLimit, upperLimit]}
                // type="number"
                allowDecimals={true}
                // label={{
                //   value: "normal range",
                //   angle: -90,
                //   position: "insideLeft",
                //   textAnchor: "middle",
                // }}
              />
              <Tooltip />
              <Legend />
              <Area
                type="monotone"
                dataKey="reportvalue"
                stroke="#82ca9d"
                fill="#82ca9d"
              />
            </AreaChart> */}
                        <div className="px-2 -mt-2">
                            {parameterTrendData?.length > 0 && (
                                <Box sx={{ width: "100%", overflow: "hidden" }}>
                                    <Paper sx={{ width: "100%", my: 1 }}>
                                        <TableContainer
                                            sx={{
                                                "&::-webkit-scrollbar": {
                                                    width: 7,
                                                    height: 10,
                                                },
                                                "&::-webkit-scrollbar-track": {
                                                    backgroundColor: "#7393B3",
                                                },
                                                "&::-webkit-scrollbar-thumb": {
                                                    backgroundColor: "lightBlue",
                                                },
                                            }}
                                            className="rounded max-h-56"
                                        >
                                            <Table
                                                size="small"
                                                stickyHeader
                                                aria-label="sticky table"
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            className="whitespace-nowrap"
                                                            style={{ background: "#F1F1F1", width: 600 }}
                                                        >
                                                            <span className="text-gray-600 font-bold">
                                                                Visit Date
                                                            </span>
                                                        </TableCell>
                                                        <TableCell
                                                            className="whitespace-nowrap"
                                                            style={{ background: "#F1F1F1", width: 350 }}
                                                        >
                                                            <span className="text-gray-600 font-bold">
                                                                Visit Time
                                                            </span>
                                                        </TableCell>
                                                        {/* <TableCell
                              className="whitespace-nowrap"
                              style={{ background: "#F1F1F1" }}
                            >
                              <span className="text-gray-600 font-bold">
                                Normal Range
                              </span>
                            </TableCell> */}
                                                        <TableCell
                                                            className="whitespace-nowrap"
                                                            style={{ background: "#F1F1F1" }}
                                                        >
                                                            <span className="text-gray-600 font-bold">
                                                                Report Value
                                                            </span>
                                                        </TableCell>{" "}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {parameterTrendData?.map((item, index) => {
                                                        return (
                                                            <TableRow>
                                                                <TableCell className="whitespace-nowrap">
                                                                    {new Date(
                                                                        item?.visitdate
                                                                    ).toLocaleDateString()}
                                                                </TableCell>
                                                                <TableCell className="whitespace-nowrap">
                                                                    {item?.visittime}
                                                                </TableCell>
                                                                {/* <TableCell className="whitespace-nowrap">
                                  {item?.normalrange}
                                </TableCell> */}
                                                                <TableCell className="whitespace-nowrap">
                                                                    {item?.reportvalue}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>
                            )}
                        </div>
                        {parameterTrendData?.length > 0 &&
                            graphData.length > 0 &&
                            lowerLimit &&
                            upperLimit && (
                                <LineChart
                                    width={chartWidth}
                                    height={300}
                                    data={graphData}
                                // margin={{
                                //   top: 5,
                                //   right: 30,
                                //   left: 20,
                                //   bottom: 5,
                                // }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />

                                    <XAxis dataKey="formattedVisitDate" />

                                    <YAxis
                                        dataKey="reportvalue"
                                        domain={[lowerLimit, upperLimit]}
                                        allowDecimals={true}
                                    />
                                    <Tooltip />
                                    <Legend />
                                    <Line
                                        type="monotone"
                                        dataKey="reportvalue"
                                        stroke="#8884d8"
                                        activeDot={{ r: 8 }}
                                    />
                                    {/* <Line type="monotone" dataKey="uv" stroke="#82ca9d" /> */}
                                </LineChart>
                            )}
                    </div>
                    {spinner ? (
                        <div className="grid justify-center">
                            <LoadingSpinner />
                        </div>
                    ) : null}
                </Box>
            </Modal>
        </>
    );
};

export default ViewTrendModal;